<template>
  <div class="follow-up-page">
    <div class="page-hero">
      <van-nav-bar title="会员详情" left-arrow :border="false" @click-left="onClickLeft" />

      <div class="hero-card">
        <div class="avatar-box">
          <img class="avatar-img" :src="memberInfos.avatarLink || defaultPhoto" alt="">
          <img class="avatar-decor" src="../assets/btn_upload head portrait@2x.png" alt="">
        </div>
        <div class="hero-name-row">
          <span class="hero-name">{{ memberInfos.name || '会员详情' }}</span>
          <span class="hero-id">#{{ memberInfos.serialNumber || '--' }}</span>
        </div>
        <div class="hero-meta">{{ sexText || '未填写性别' }} · {{ getFormatTime(memberInfos.birthday) || '未填写生日' }} · {{
          memberInfos.hometown || '未填写籍贯' }}</div>
        <div class="hero-tags">
          <span class="hero-tag">{{ memberInfos.companyName || '未填写公司' }}</span>
          <span class="hero-tag">{{ memberInfos.positionTitle || '未填写岗位' }}</span>
          <span class="hero-tag" :class="{ disabled: hasOtherMatchmaker }">{{ hasOtherMatchmaker ? '已有红娘跟进（可申请接手）' :
            '可继续跟进' }}</span>
        </div>
      </div>
    </div>

    <div class="page-content">
      <div class="section-card relation-info-card" v-if="relationInfo">
        <div class="section-title">跟进关联</div>
        <div class="relation-item" v-if="relationInfo.followUpMatchmaker">
          <div class="relation-item-label">跟进红娘</div>
          <div class="relation-item-value">
            <span class="matchmaker-name-tag">{{ relationInfo.followUpMatchmaker.name }}</span>
          </div>
        </div>
        <div class="relation-item" v-if="relationInfo.myRecommendedTarget">
          <div class="relation-item-label">推荐对象</div>
          <div class="relation-item-value">
            <span class="member-name-text">{{ relationInfo.myRecommendedTarget.memberName }}</span>
            <span class="member-serial-text">#{{ relationInfo.myRecommendedTarget.serialNumber }}</span>
          </div>
        </div>
      </div>

      <div class="section-card">
        <div class="section-title">基础资料</div>
        <div class="info-grid">
          <div v-for="item in basicInfoItems" :key="item.label" class="info-cell">
            <div class="cell-label">{{ item.label }}</div>
            <div class="cell-value">{{ item.value || '--' }}</div>
          </div>
        </div>
      </div>

      <div class="section-card">
        <div class="section-title">工作与联系</div>
        <div class="info-grid secondary-grid">
          <div v-for="item in workInfoItems" :key="item.label" class="info-cell">
            <div class="cell-label">{{ item.label }}</div>
            <div class="cell-value">{{ item.value || '--' }}</div>
          </div>
        </div>
        <div class="long-row">
          <div class="row-label">个人家庭情况</div>
          <div class="row-value multiline">{{ memberInfos.personalFamilyDescription || '未填写' }}</div>
        </div>
      </div>

      <div class="section-card">
        <div class="section-title">详细说明</div>

        <div class="action-row" @click="handleOpenTagSelector(2)">
          <div class="row-main">
            <div class="row-label">择偶意向</div>
            <div class="row-value multiline">{{ spouseRequirementTagsText || '未填写' }}</div>
          </div>
          <van-icon name="arrow" />
        </div>

        <div class="action-row" @click="handleOpenTagSelector(1)">
          <div class="row-main">
            <div class="row-label">性格描述</div>
            <div class="row-value multiline">{{ personalityTagsText || '未填写' }}</div>
          </div>
          <van-icon name="arrow" />
        </div>

        <div class="action-row" @click="handleOpenInterestTags">
          <div class="row-main">
            <div class="row-label">兴趣爱好描述</div>
            <div class="row-value multiline">{{ interestTexts.length ? interestTexts.join('、') : '未填写' }}</div>
          </div>
          <van-icon name="arrow" />
        </div>

        <div class="action-row" @click="handleOpenFavoriteMembers">
          <div class="row-main">
            <div class="row-label">心仪对象</div>
            <div class="row-value multiline">查看</div>
          </div>
          <van-icon name="arrow" />
        </div>

        <div class="action-row" @click="handleOpenFollowUp">
          <div class="row-main">
            <div class="row-label">跟进情况</div>
            <div class="row-value multiline">{{ followUpSummary }}</div>
          </div>
          <van-icon name="arrow" />
        </div>

        <div class="field-row" @click="handleSelectTargetMember">
          <div class="row-label">推荐对象</div>
          <div class="field-wrap">
            <van-field v-model="memberInfos.theOtherHalfName" placeholder="请选择推荐对象" input-align="right"
              ref="theOtherHalfName" :readonly="false" />
          </div>
          <van-icon name="arrow" />
        </div>

        <div class="field-row field-row-readonly" @click="toDetail">
          <div class="row-label">推荐会员编号</div>
          <div class="field-wrap">
            <van-field :value="memberInfos.theOtherHalfSerialNumber || ''" placeholder="选择后自动带出" input-align="right"
              readonly />
          </div>
        </div>

        <div class="field-row field-row-readonly">
          <div class="row-label">推荐对象单位</div>
          <div class="field-wrap">
            <van-field v-model="memberInfos.theOtherHalfCompany" placeholder="选择后自动带出" input-align="right" readonly />
          </div>
        </div>

        <div class="action-row" @click="handleCilckFollowUp">
          <div class="row-main">
            <div class="row-label">跟进记录</div>
            <div class="row-value multiline">{{ memberInfos.followUpRecords || '暂无跟进记录' }}</div>
          </div>
          <van-icon name="arrow" />
        </div>
      </div>

      <div class="section-card photo-card">
        <div class="section-title">会员相册</div>
        <van-uploader v-model="memberInfos.personalPhotos" disabled :deletable="false" />
      </div>
    </div>

    <div class="follow-actions">
      <van-button round type="default" class="action-btn secondary" @click="contactMember">联系会员</van-button>
      <van-button round type="info" class="action-btn primary" @click="followUpOk" v-if="!canFlow">保存跟进</van-button>
      <van-button round type="info" class="action-btn primary" @click="followUpOk" v-if="canFlow">申请跟进</van-button>
      <van-button round type="default" class="action-btn secondary" @click="followUpCancal" v-else>取消跟进</van-button>
    </div>

    <van-popup v-model="followUpStatusPicker" position="bottom" :style="{ height: '60%' }"
      :class="{ 'filed-checked': checkout }" safe-area-inset-bottom>
      <div class="followUp-pop">
        <div class="pop-header">跟进状态</div>
        <div class="pop-content">
          <div class="pop-content-title">状态选择</div>
          <div class="pop-content-btn">
            <!-- <van-button round type="info" @click="checkBtn(1)"
              :class="{ 'pop-content-btnCheck': followUpStatus === 1 }">启动</van-button>
            <van-button round type="info" @click="checkBtn(2)"
              :class="{ 'pop-content-btnCheck': followUpStatus === 2 }">过程</van-button>
            <van-button round type="info" @click="checkBtn(3)"
              :class="{ 'pop-content-btnCheck': followUpStatus === 3 }">结果</van-button>
            <van-button round type="info" @click="checkBtn(5)"
              :class="{ 'pop-content-btnCheck': followUpStatus === 5 }">互加微信</van-button> -->
            <van-button round type="info" @click="checkBtn(6)"
              :class="{ 'pop-content-btnCheck': followUpStatus === 6 }">了解中</van-button>
            <van-button round type="info" @click="checkBtn(7)"
              :class="{ 'pop-content-btnCheck': followUpStatus === 7 }">交往中</van-button>
            <van-button round type="info" @click="checkBtn(8)"
              :class="{ 'pop-content-btnCheck': followUpStatus === 8 }">已订婚</van-button>
            <van-button round type="info" @click="checkBtn(9)"
              :class="{ 'pop-content-btnCheck': followUpStatus === 9 }">已领证</van-button>
          </div>
          <div class="pop-content-title">具体情况填写<span>（必填）</span></div>
          <van-field v-model="message" rows="2" autosize type="textarea" @focus="focusFiled" @blur="blurFiled" />
        </div>
        <div class="pop-footer">
          <van-button round type="info" class="pop-footer-cancal" @click="handleCancel">取消</van-button>
          <van-button round type="info" class="pop-footer-success" @click="handleOk">确认</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getMatchmakerViewMemberInfo } from '@/api/user';
import { Toast } from 'vant';
import { mapActions } from 'vuex';
import defaultPhoto from '../assets/defaultPhoto.png';
import { getFollowUpProgressListByMemberId, postFollowUpMembers, cancelFollowUpMembers, getFollowUpRelationshipByMemberId } from '../api/matchmakerInfo';

export default {
  data() {
    return {
      defaultPhoto,
      memberInfos: {
        followUpRecords: '',
        canFlow: true,
        serialNumber: '',
        name: '',
        sex: '',
        avatarLink: '',
        birthday: '',
        tikTok: '',
        hometown: '',
        height: '',
        education: '',
        descriptionOfPersonalInterests: '',
        personalityTags: [],
        spouseRequirementTags: [],
        descriptionOfSpouseSelectionRequirements: '',
        personalCharacterDescription: '',
        followUpStatus: 0,
        theOtherHalfName: '',
        theOtherHalfCompany: '',
        theOtherHalfMemberInfoId: '',
        theOtherHalfSerialNumber: '',
        personalPhotos: []
      },
      checkout: false,
      followUpStatusData: ['微信聊天中', '已见面互有好感恋爱中', '已见家长', '已订婚领取结婚证', '其它情况'],
      statusData: ['启动', '过程', '结果', '取消跟进', '互加微信', '了解中', '交往中', '已订婚', '已领证'],
      followUpStatus: 0,
      message: '',
      educationData: ['大专', '本科', '硕士', '博士', '高中及以下'],
      checkboxData: ['球类运动（篮球、兵乓球、羽毛球等）', '体育运动（跑步、跳绳、健身等）', '户外活动（旅游、登山）', '文艺类（唱歌、跳舞、乐器）', '娱乐类（逛街、看电影、看书）', '冒险类（潜水，攀岩）', '智力类（拼图、拆装）', '游戏类（桌游、网游）', '休闲类（园艺、写生、摄影）', '美食类（火锅、烧烤等）', '烹饪类（中餐、西餐、糕点）', '其他'],
      followUpStatusPicker: false,
      desctColumns: ['自己有住房', '已购房', '计划购房', '无计划'],
      maritalStatusData: ['未婚', '离异/无子女', '离异有子女', '其他'],
      personalBeliefsData: ['基督教', '天主教', '佛教', '伊斯兰教', '无', '其它'],
      userInfo: {},
      hasOtherMatchmaker: false,
      relationInfo: null
    };
  },
  computed: {
    sexText() {
      if (!this.memberInfos.sex) return '';
      return this.memberInfos.sex === 1 ? '男' : '女';
    },
    maritalStatusText() {
      return this.memberInfos.maritalStatus ? this.maritalStatusData[this.memberInfos.maritalStatus - 1] : '';
    },
    educationText() {
      return this.memberInfos.education ? this.educationData[this.memberInfos.education - 1] : '';
    },
    housingText() {
      return this.memberInfos.housingSituation ? this.desctColumns[this.memberInfos.housingSituation - 1] : '';
    },
    beliefsText() {
      return this.memberInfos.personalBeliefs ? this.personalBeliefsData[this.memberInfos.personalBeliefs - 1] : '';
    },
    interestTexts() {
      const interests = Array.isArray(this.memberInfos.descriptionOfPersonalInterests)
        ? this.memberInfos.descriptionOfPersonalInterests
        : [];
      return interests
        .map(item => Number(item))
        .filter(Boolean)
        .map(item => this.checkboxData[item - 1])
        .filter(Boolean);
    },
    followUpSummary() {
      const { followUpStatus, followUpDescription } = this.memberInfos;
      if (followUpStatus && this.statusData[followUpStatus - 1]) {
        return `${this.statusData[followUpStatus - 1]}：${followUpDescription || ''}`;
      }
      return '暂无跟进情况';
    },
    personalityTagsText() {
      return (this.memberInfos.personalityTags || [])
        .map(tag => tag.tagName)
        .filter(Boolean)
        .join('、');
    },
    spouseRequirementTagsText() {
      return (this.memberInfos.spouseRequirementTags || [])
        .map(tag => tag.tagName)
        .filter(Boolean)
        .join('、');
    },
    basicInfoItems() {
      return [
        { label: '编号', value: this.memberInfos.serialNumber },
        { label: '性别', value: this.sexText },
        { label: '出生年月', value: this.getFormatTime(this.memberInfos.birthday) },
        { label: '籍贯', value: this.memberInfos.hometown },
        { label: '身高', value: this.memberInfos.height ? `${this.memberInfos.height}CM` : '' },
        { label: '体重', value: this.memberInfos.weight ? `${this.memberInfos.weight}KG` : '' },
        { label: '婚姻状态', value: this.maritalStatusText },
        { label: '学历', value: this.educationText },
        { label: '民族', value: this.memberInfos.nation },
        { label: '住房情况', value: this.housingText },
        { label: '个人信仰', value: this.beliefsText },
        { label: '毕业学校', value: this.memberInfos.graduateSchool }
      ];
    },
    workInfoItems() {
      return [
        { label: '公司名称', value: this.memberInfos.companyName },
        { label: '岗位名称', value: this.memberInfos.positionTitle },
        { label: '联系电话', value: this.memberInfos.contactNumber },
        { label: '入会推荐人', value: this.memberInfos.referrer },
        { label: '抖音号', value: this.memberInfos.tikTok }
      ];
    }
  },
  methods: {
    ...mapActions(['CreateConversation', 'SetCurrentConversation']),
    focusFiled() {
      if (navigator.userAgent) {
        let isHuawei = navigator.userAgent.toLowerCase().match(/huawei/i) === 'huawei';
        if (isHuawei) {
          this.checkout = true;
        }
      }
    },
    blurFiled() {
      this.checkout = false;
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    handleCilckFollowUp() {
      if (this.memberInfos.followUpRecords !== '暂无跟进记录') {
        this.$router.push({ path: `/followUpRecords/${this.$route.params.id}` });
      }
    },
    validateFollowUpOwnership(cancelMessage = '当前会员已有其他红娘跟进') {
      const baseInfo = this.$store.getters.baseInfo;
      if (this.memberInfos.matchmakerInfoId && baseInfo.id !== this.memberInfos.matchmakerInfoId) {
        Toast.fail({ message: cancelMessage });
        return false;
      }
      return true;
    },
    validateFollowUpForm() {
      if (!this.memberInfos.theOtherHalfMemberInfoId) {
        Toast.fail({ message: '请选择推荐对象' });
        return false;
      }
      if (!this.memberInfos.followUpStatus) {
        Toast.fail({ message: '请选择状态' });
        return false;
      }
      if (!this.memberInfos.followUpDescription) {
        Toast.fail({ message: '请输入具体情况' });
        return false;
      }
      return true;
    },
    async contactMember() {
      if (!this.validateFollowUpOwnership()) {
        return;
      }
      try {
        Toast.loading({ message: '正在打开聊天...', forbidClick: true });
        const baseInfo = this.$store.getters.baseInfo || {};
        const conversationRes = await this.CreateConversation({
          targetUserId: this.memberInfos.id || this.$route.params.id,
          targetUserType: 'Member'
        });
        Toast.clear();
        await this.SetCurrentConversation(conversationRes);
        this.$router.push({
          path: `/chatRoom/${conversationRes.id}`,
          query: {
            matchmakerId: baseInfo.id,
            memberId: this.memberInfos.id || this.$route.params.id,
            matchmakerName: baseInfo.name,
            memberName: this.memberInfos.name,
            matchmakerAvatar: baseInfo.avatarLink,
            memberAvatar: this.memberInfos.avatarLink
          }
        });
      } catch (error) {
        Toast.clear();
        console.error('联系会员失败:', error);
        Toast.fail('联系会员失败，请重试');
      }
    },
    followUpCancal() {
      const data = this.userInfo;
      if (!this.validateFollowUpOwnership('不能取消其他红娘的跟进')) {
        return;
      }
      const params = {
        memberInfoId: data.id,
        matchmakerId: this.$store.getters.baseInfo.id
      };
      cancelFollowUpMembers(params).then(res => {
        if (res.code === 20000) {
          Toast.success({ message: '取消跟进成功' });
          this.$router.go(-1);
        }
      });
    },
    followUpOk(noGoToBack) {
      if (!this.validateFollowUpForm()) {
        return;
      }
      const params = {
        memberInfoId: this.$route.params.id,
        theOtherHalfName: this.memberInfos.theOtherHalfName,
        theOtherHalfCompany: this.memberInfos.theOtherHalfCompany,
        theOtherHalfMemberInfoId: this.memberInfos.theOtherHalfMemberInfoId,
        theOtherHalfSerialNumber: this.memberInfos.theOtherHalfSerialNumber,
        followUpStatus: this.memberInfos.followUpStatus,
        followUpDescription: this.memberInfos.followUpDescription,
        matchmakerId: this.$store.getters.baseInfo.id
      };
      postFollowUpMembers(params).then(res => {
        if (res.code === 20000) {
          Toast.success({ message: '跟进成功' });
          if (!(noGoToBack != null && noGoToBack === true)) {
            this.$router.go(-1);
          }
        }
      });
    },
    handleSelectTargetMember() {
      this.$router.push({
        path: `/followUpTargetSelector/${this.$route.params.id}`,
        query: {
          currentMemberSex: this.memberInfos.sex
        }
      });
    },
    handleOpenFavoriteMembers() {
      this.$router.push({
        path: '/myFavoriteMembers',
        query: {
          memberId: this.$route.params.id,
          memberName: this.memberInfos.name || '',
          readonly: '1',
          source: 'followUp'
        }
      });
    },
    handleOpenTagSelector(tagType) {
      const selectedTags = tagType === 1
        ? (this.memberInfos.personalityTags || [])
        : (this.memberInfos.spouseRequirementTags || []);
      const selectedText = tagType === 1 ? this.personalityTagsText : this.spouseRequirementTagsText;
      this.$router.push({
        path: '/tagSelector',
        query: {
          tagType: String(tagType),
          memberId: this.$route.params.id,
          readonly: '1',
          selectedTags: JSON.stringify(selectedTags),
          selectedText
        }
      });
    },
    handleOpenInterestTags() {
      this.$router.push({ path: `/checkInterests/${this.$route.params.id}` });
    },
    handleOk() {
      this.memberInfos.followUpDescription = this.message;
      this.memberInfos.followUpStatus = this.followUpStatus;
      if (!this.validateFollowUpForm()) {
        return;
      }
      this.followUpStatusPicker = false;
      this.followUpOk(true);
    },
    handleCancel() {
      this.message = this.memberInfos.followUpDescription;
      this.followUpStatus = this.memberInfos.followUpStatus;
      this.followUpStatusPicker = false;
    },
    handleOpenFollowUp() {
      this.followUpStatusPicker = true;
      this.message = this.memberInfos.followUpDescription;
      this.followUpStatus = this.memberInfos.followUpStatus;
    },
    checkBtn(num) {
      this.followUpStatus = num;
    },
    toDetail() {
      if (this.memberInfos.theOtherHalfMemberInfoId) {
        this.$router.push({ path: `/detailInformation/${this.memberInfos.theOtherHalfMemberInfoId}` });
      }
    }
  },
  mounted() {
    this.$refs.theOtherHalfName;
    this.$refs.theOtherHalfCompany;
  },
  created() {
      const memberInfoId = this.$route.params.id;
      // 独立加载跟进关系，不依赖 getMatchmakerViewMemberInfo 的返回
      getFollowUpRelationshipByMemberId({ memberInfoId }).then(res => {
        if (res.code === 20000 && res.data) {
          this.relationInfo = res.data;
        }
      }).catch(() => {});

    getMatchmakerViewMemberInfo(memberInfoId).then(res => {
      if (res.data) {
        let data = JSON.parse(JSON.stringify(res.data));
        this.userInfo = JSON.parse(JSON.stringify(res.data));
        data.personalPhotos = data.personalPhotos || [];
        data.personalityTags = data.personalityTags || [];
        data.spouseRequirementTags = data.spouseRequirementTags || [];
        data.descriptionOfSpouseSelectionRequirements = data.descriptionOfSpouseSelectionRequirements || '';
        data.personalCharacterDescription = data.personalCharacterDescription || '';
        if (data.descriptionOfPersonalInterests) {
          data.descriptionOfPersonalInterests = data.descriptionOfPersonalInterests.split(',');
        }
        const params = {
          memberInfoId: this.$route.params.id
        };
        this.memberInfos = data;
        // 检查推荐对象选择回传数据（必须在 this.memberInfos = data 覆盖之后）
        if (window._targetMemberSelected) {
          const d = window._targetMemberSelected;
          this.memberInfos.theOtherHalfMemberInfoId = d.targetMemberId;
          this.memberInfos.theOtherHalfName = d.targetMemberNickName || "";
          this.memberInfos.theOtherHalfSerialNumber = d.targetMemberSerialNumber || "";
          this.memberInfos.theOtherHalfCompany = d.targetMemberCompany || "";
          delete window._targetMemberSelected;
        }
        const baseInfo = this.$store.getters.baseInfo;
        if (this.memberInfos.matchmakerInfoId && baseInfo.id !== this.memberInfos.matchmakerInfoId) {
          this.hasOtherMatchmaker = true;
        }
        const {
          targetMemberId,
          targetMemberName,
          targetMemberSerialNumber,
          targetMemberCompany
        } = this.$route.query;
        if (targetMemberId) {
          this.memberInfos.theOtherHalfMemberInfoId = targetMemberId;
          this.memberInfos.theOtherHalfSerialNumber = targetMemberSerialNumber || '';
          this.memberInfos.theOtherHalfCompany = targetMemberCompany || '';
        }
        getFollowUpProgressListByMemberId(params).then(item => {
          this.canFlow = true;
          if (item.data) {
            if (item.data.length > 0) {
              let obj = item.data[0];
              this.canFlow = obj.matchmakerInfoId != this.$store.getters.baseInfo.id
              let followUpRecords = '';
              if (obj.followUpStatus === 4) {
                followUpRecords = this.getCompleteTime(obj.createOn) + '由' + obj.operatorName + '取消跟进';
              } else {
                followUpRecords = this.getCompleteTime(obj.createOn) + '由' + obj.matchmakerName + '申请跟进';
              }
              this.$set(this.memberInfos, 'followUpRecords', followUpRecords);
            } else {
              this.$set(this.memberInfos, 'followUpRecords', '暂无跟进记录');
            }
          }
        });
      }
    });
  }
};
</script>
<style lang="less" src='../style/followUpPage.less' />



// WEBPACK FOOTER //
// src/views/followUpPage.vue